<div class="row container-fluid">
  <div class="col-md-6 head-top">
    <div class="send-money ">

      <div class="heading-text">You are Paying bill to:</div>
      <div class="card border-0" style="border-radius:5px">
        <div class="card-body bg-alice radius-5">
          <div class="row">
            <div class="col-md-8 col-sm-8">
              <h5 class=" sm-16">{{ billerService.biller.biller_name }}</h5>
            </div>
            <div class="col-md-4 col-sm-4"><img src="assets/images/check.png">
            </div>
          </div>
          <small class="custom-text-font text-secondary ">
            {{ billerService.biller.biller_name }} {{ billerService.biller.biller_input_1_name }} ending in {{
            billerService.biller.biller_input_1%10000 ?billerService. biller.biller_input_1%10000 :
            billerService.biller.biller_input_1}}
          </small>
        </div>
      </div>



      <div class="pt-3">
        <form>
          <div class="div-block-13 bg-white w-100">
            <input type="number" style="background:none!important; border:none;"
              class="text-field w-input m-0 p-3 border-0" def="10" autofocus="true" maxlength="256" name="sending_amt"
              required readonly [(ngModel)]="billerService.finalData.amount_cad">
            <div class="w-dropdown bg-alice radiusr-5">
              <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
                <div id="from-currency" class="div-block-11 mr-0">
                  <div class="selected-currency-code mr-1">CAD</div>
                  <img [src]="'assets/images/cad.png'" loading="lazy" width="25"
                    alt="n2xpress - Money Transfer - Canadian Dollar" class="image-7 m-0 ">
                </div>
              </div>
              <nav id="from-currency-list" class="dropdown-list-2 w-dropdown-list">
                <div class="div-block-14">
                  <div class="div-block-11-copy">
                    <div class="selected-currency-code">CAD</div>
                    <img [src]="'assets/images/cad.png'" loading="lazy" width="25"
                      alt="n2xpress - Money Transfer - Canadian Dollar" class="image-7">
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div class="rate-panel">
            <div class="div-block-15"></div>
            <div class="div-block-16">
              <div class="div-block-18 py-2">
                <span class="bg-alice rounded-circle symbol color-blue">x</span>
                <div class="rate-figure">
                  <div id="currency-rate" class="text-block-12 sm-12">{{ billerService.finalData.exchange_rate_cad }}
                  </div>
                </div>
                <div class="rate-currency">
                  <div id="exchange-currency" class="rate-currency-text sm-12">CAD</div>

                </div>
                <div class="rate-explainer">
                  <div class="explainer-text sm-10">Your exchange rate</div>
                </div>
              </div>

              <div class="div-block-13-copy bg-white w-100">
                <input type="number" style="background:none!important; border:none;"
                  class="text-field w-input m-0 p-3 border-0" name="send_amt" maxlength="256" readonly
                  [(ngModel)]="billerService.finalData['biller_amount_local']">
                <div class="w-dropdown bg-alice radiusr-5">
                  <div class="cxy-dropdown-toggle w-dropdown-toggle p-3">
                    <div id="to-currency" class="div-block-11 mr-0">
                      <div class="text-block-10">{{ billerService.biller.currency }}</div>
                      <img [src]="'assets/images/' +  billerService.biller.currency.toLowerCase() +'.png'"
                        loading="lazy" width="22" [alt]="'n2xpress - Money Transfer - ' + billerService.biller.currency"
                        class="image-7 m-0">
                    </div>

                  </div>
                </div>
              </div>
              <div class="div-block-17 py-2">
                <span class="bg-alice rounded-circle symbol color-blue">+</span>
                <div>
                  <div class="fee-figure sm-10">{{ billerService.finalData.transaction_fees }}</div>
                </div>
                <div class="rate-currency">
                  <div class="rate-currency-text sm-12">CAD</div>
                </div>
                <div class="fee-explainer-text">
                  <div class="explainer-text sm-10">Processing fee</div>
                </div>
              </div>
              <div class="div-block-17 py-2">
                <span class="bg-alice rounded-circle symbol color-blue">+</span>
                <div>
                  <div class="fee-figure sm-12">{{ billerService.finalData.gateway_fees }}</div>
                </div>
                <div class="rate-currency">
                  <div class="rate-currency-text sm-12">{{ billerService.paymentMethod.gateway_fee_type ? '%' : 'CAD' }}
                  </div>
                </div>
                <div class="fee-explainer-text">
                  <div class="explainer-text sm-10">Payment fee</div>
                </div>
              </div>
              <div class="div-block-18-copy">
                <span class="bg-alice rounded-circle symbol color-blue">=</span>
                <div class="rate-figure">
                  <div id="currency-rate" class="text-block-12 sm-12">{{ billerService.finalData.total_amount }}</div>
                </div>
                <div class="rate-currency">
                  <div id="exchange-currency" class="rate-currency-text sm-12">CAD</div>

                </div>
                <div class="rate-explainer">
                  <div class="explainer-text sm-10">Total</div>
                </div>

              </div>
              <div class="div-block-18-copy"
                *ngIf="billerService.finalData.celoData != null && billerService.finalData.celoData.paymentSelectedoption.payment_id == 6">
                <span class="bg-alice rounded-circle symbol color-blue">=</span>
                <div class="rate-figure">
                  <div id="currency-rate" class="text-block-12 sm-12">{{
                    billerService.finalData.celoData.data.celo_value_plus_fee }}</div>
                </div>
                <div class="rate-explainer">
                  <div class="secondary-text sm-10">cUSD</div>
                </div>
              </div>
              <div class="div-block-18-copy"></div>

              <div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between my-5 address_field" style="margin-top: 75px !important;">
            <br>
            <button (click)="billerService.prevPage('biller2')" type="button"
              class="btn transparent-btn primary-text back-btn">Back</button>

            <button (click)="billerService.payToGateway()" type="button" class="btn btn-primary w-100">Confirm and pay
              now</button>

          </div>
        </form>
        <!-- <p-dialog header="Debit Authorization" [(visible)]="displayDebitAuthorization" [style]="{width: '50vw'}" [baseZIndex]="10000">
          <div [innerHTML]="debitAuthorization"></div>
          <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" (click)="displayDebitAuthorization=false" label="Disagree" styleClass="p-button-text"></p-button>
            <p-button icon="pi pi-check" (click)="onConfirmSendMoney()"  label="Confirm and Pay" styleClass="p-button-text"></p-button>
          </ng-template>
        </p-dialog> -->
      </div>



    </div>
  </div>

  <div *ngIf="limit_error">
    <div class="alert alert-danger alert-dismissible">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <p>{{limit_error}}</p>
    </div>
</div>
</div>